const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (window.location.hostname === "localhost"
    ? ""
    : `https://api.${window.location.hostname.replace(/^www\./, "")}`);

export async function fetchAgents({ status, tag } = {}) {
  const params = new URLSearchParams();
  if (status && status !== "all") params.set("status", status);
  if (tag) params.set("tag", tag);

  const res = await fetch(`${API_BASE}/registry/agents?${params.toString()}`);
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

export async function fetchHealth() {
  const res = await fetch(`${API_BASE}/api/health`);
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}
